export const RELATED_FIELD_TYPES = [
  'Multi Line Text', 
  'HTML', 
  'Line', 
  'Icons', 
  'Rectangle', 
  'Circle', 
  'Background Theme Image'
];

export const RELATED_FIELD_DEFAULT = {
  field: '',
  margin: 5,
  move_down_only: false
}
